import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AccountDeletion.module.css';

const AccountDeletion: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>Account Deletion Request</h1>
        
        <div className={styles.section}>
          <h2>WealthPlay Account Deletion</h2>
          <p>
            We respect your privacy and provide you with the ability to delete your WealthPlay account 
            and all associated data at any time.
          </p>
        </div>

        <div className={styles.section}>
          <h2>Preferred: In-App Deletion</h2>
          <p>
            The quickest way to delete your account is directly from the WealthPlay app:
          </p>
          <ol className={styles.steps}>
            <li>Open the WealthPlay app</li>
            <li>Go to the Profile page (bottom navigation)</li>
            <li>Scroll to the bottom of the page</li>
            <li>Tap the "Delete Account" button</li>
            <li>Confirm your decision in the dialog</li>
          </ol>
          <p style={{ marginTop: '16px', fontWeight: 600, color: '#059669' }}>
            Your account will be deleted immediately after confirmation.
          </p>
        </div>

        <div className={styles.section}>
          <h2>Alternative: Email Request</h2>
          <p>If you're unable to use the in-app deletion, you can also request deletion via email:</p>
          <ol className={styles.steps}>
            <li>Send an email to <a href="mailto:devan@wealth-play.com?subject=Account Deletion Request">devan@wealth-play.com</a></li>
            <li>Use the subject line: "Account Deletion Request"</li>
            <li>Include the email address associated with your WealthPlay account</li>
            <li>You will receive a confirmation email within 48 hours</li>
            <li>Your account and data will be deleted within 30 business days</li>
          </ol>
        </div>

        <div className={styles.section}>
          <h2>What Data Will Be Deleted</h2>
          <p>When you request account deletion, the following data will be permanently removed:</p>
          <ul className={styles.dataList}>
            <li>Your account profile information (email, password)</li>
            <li>All transaction history and financial data</li>
            <li>Bank account connections via Plaid</li>
            <li>Game progress and achievements</li>
            <li>Quest completion history</li>
            <li>All personal preferences and settings</li>
          </ul>
        </div>

        <div className={styles.section}>
          <h2>Data Retention</h2>
          <p>
            After requesting deletion, your data will be completely removed. For in-app deletions, this happens immediately. For email requests, data will be removed within 30 business days. 
            We do not retain any personal information after the deletion process is complete.
          </p>
          <p>
            Exception: We may retain certain anonymized, aggregated data for analytics purposes, 
            but this data cannot be linked back to your individual account.
          </p>
        </div>

        <div className={styles.contactSection}>
          <h3>Need Help?</h3>
          <p>
            If you have any questions about account deletion or data privacy, please contact us at{' '}
            <a href="mailto:devan@wealth-play.com">devan@wealth-play.com</a>
          </p>
        </div>

        <div className={styles.footer}>
          <button 
            onClick={handleGoBack}
            className={styles.backLink}
            style={{
              background: 'none',
              border: 'none',
              color: 'hsl(260, 80%, 74%)',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontSize: 'inherit',
              fontFamily: 'inherit'
            }}
          >
            ← Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountDeletion;